// extracted by mini-css-extract-plugin
module.exports = {"list":"_ProcessorAgreementBox_list_3uLN4","roman":"_ProcessorAgreementBox_roman_qU6Xw","dash":"_ProcessorAgreementBox_dash_2qctF","circle":"_ProcessorAgreementBox_circle_2MhEl"};